import { canvasUtils } from '@pixi/canvas-renderer';
import { NineSlicePlane } from '@pixi/mesh-extras';

NineSlicePlane.prototype._cachedTint = 16777215;
NineSlicePlane.prototype._tintedCanvas = null;
NineSlicePlane.prototype._canvasUvs = null;
NineSlicePlane.prototype._renderCanvas = function _renderCanvas(renderer) {
  const context = renderer.canvasContext.activeContext;
  const transform = this.worldTransform;
  const isTinted = this.tint !== 16777215;
  const texture = this.texture;
  if (!texture.valid) {
    return;
  }
  if (isTinted) {
    if (this._cachedTint !== this.tint) {
      this._cachedTint = this.tint;
      this._tintedCanvas = canvasUtils.getTintedCanvas(this, this.tint);
    }
  }
  const textureSource = !isTinted ? texture.baseTexture.getDrawableSource() : this._tintedCanvas;
  if (!this._canvasUvs) {
    this._canvasUvs = [0, 0, 0, 0, 0, 0, 0, 0];
  }
  const vertices = this.vertices;
  const uvs = this._canvasUvs;
  const u0 = isTinted ? 0 : texture.frame.x;
  const v0 = isTinted ? 0 : texture.frame.y;
  const u1 = u0 + texture.frame.width;
  const v1 = v0 + texture.frame.height;
  uvs[0] = u0;
  uvs[1] = u0 + this._leftWidth;
  uvs[2] = u1 - this._rightWidth;
  uvs[3] = u1;
  uvs[4] = v0;
  uvs[5] = v0 + this._topHeight;
  uvs[6] = v1 - this._bottomHeight;
  uvs[7] = v1;
  for (let i = 0; i < 8; i++) {
    uvs[i] *= texture.baseTexture.resolution;
  }
  context.globalAlpha = this.worldAlpha;
  renderer.canvasContext.setBlendMode(this.blendMode);
  renderer.canvasContext.setContextTransform(transform, this.roundPixels);
  for (let row = 0; row < 3; row++) {
    for (let col = 0; col < 3; col++) {
      const ind = col * 2 + row * 8;
      const sw = Math.max(1, uvs[col + 1] - uvs[col]);
      const sh = Math.max(1, uvs[row + 5] - uvs[row + 4]);
      const dw = Math.max(1, vertices[ind + 10] - vertices[ind]);
      const dh = Math.max(1, vertices[ind + 11] - vertices[ind + 1]);
      context.drawImage(textureSource, uvs[col], uvs[row + 4], sw, sh, vertices[ind], vertices[ind + 1], dw, dh);
    }
  }
};
//# sourceMappingURL=NineSlicePlane.mjs.map
